// src/App.jsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext.jsx';
import { CartProvider } from './context/CartContext.jsx';
import Layout from './components/layout/Layout.jsx';
import ProtectedRoute from './components/common/ProtectedRoute.jsx';
import { clearExpiredTokens } from './utils/tokenUtils';
import ScrollToTop from './components/common/ScrollToTop.jsx';
import AdminRoute from "./context/AdminRoute.jsx";
// At the top of src/App.jsx
import ProductManagement from './pages/ProductManagement.jsx';
import AdminDashboard from "./pages/AdminDashboard.jsx";
import CollegeManagement from './pages/CollegeManagement.jsx';
import AdminOrderManagement from './pages/AdminOrderManagement.jsx';

// Pages
import HomePage from './pages/HomePage.jsx';
import ProductsPage from './pages/ProductsPage.jsx';
import ProductDetailPage from './pages/ProductDetailPage.jsx';
import CartPage from './pages/CartPage.jsx';
import CheckoutPage from './pages/CheckoutPage.jsx';
import OrdersPage from './pages/OrdersPage.jsx';
import OrderDetailPage from './pages/OrderDetailPage.jsx';
import LoginPage from './pages/LoginPage.jsx';
import SignupPage from './pages/SignupPage.jsx';
import ProfilePage from './pages/ProfilePage.jsx';
import ContactPage from './pages/ContactPage';
import ShippingPolicyPage from './pages/ShippingPolicyPage';
import ReturnPolicyPage from './pages/ReturnPolicyPage';
import FAQPage from './pages/FAQPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage.jsx';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  // ⭐ Clear expired tokens on app startup
  useEffect(() => {
    const wasCleared = clearExpiredTokens();
    if (wasCleared) {
      console.log('Expired tokens cleared on app startup');
    }
  }, []);

  return (
    <GoogleOAuthProvider clientId="790510114818-8gjdhhb8edc5p68i2nu85i3uctjttgla.apps.googleusercontent.com">
      <AuthProvider>
        <CartProvider>
          <Router>
            <Layout>
              <ScrollToTop /> 
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<HomePage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/products/:id" element={<ProductDetailPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/shipping-policy" element={<ShippingPolicyPage />} />
                <Route path="/return-policy" element={<ReturnPolicyPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/forgotPassword" element={<ForgotPasswordPage />} />
                
                {/* Protected Routes */}
                <Route
                  path="/cart"
                  element={
                    <ProtectedRoute>
                      <CartPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/checkout"
                  element={
                    <ProtectedRoute>
                      <CheckoutPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/orders"
                  element={
                    <ProtectedRoute>
                      <OrdersPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/orders/:id"
                  element={
                    <ProtectedRoute>
                      <OrderDetailPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  }
                />
                {/* Protected Admin Routes */}
  <Route 
    path="/admin/dashboard" 
    element={
      <AdminRoute>
        <AdminDashboard />
      </AdminRoute>
    } 
  />
  <Route 
    path="/admin/products" 
    element={
      <AdminRoute>
        <ProductManagement />
      </AdminRoute>
    } 
  />
  <Route path="/admin/colleges" element={<CollegeManagement />} />
  <Route
    path="/admin/orders"
    element={
      <AdminRoute>
        <AdminOrderManagement />
      </AdminRoute>
    }
  />
                
                {/* 404 - Redirect to home */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </Router>
        </CartProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;